import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/functions'

// firebase init - add your own config here
const firebaseConfig = {
    apiKey: "AIzaSyCJEbppSOARXnpf7XjK_gNpGihGBgk3fIY",
    authDomain: "client-identity-checker.firebaseapp.com",
    databaseURL: "https://client-identity-checker.firebaseio.com",
    projectId: "client-identity-checker",
    storageBucket: "client-identity-checker.appspot.com",
    messagingSenderId: "601561917582",
    appId: "1:601561917582:web:d67fbbf80987a0a24101df",
    measurementId: "G-XQS9LGQF2E"
}
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.database()
const auth = firebase.auth()
const functions = firebase.functions()

// collection references
const data = db.ref('data')

// export utils/refs
export {
    db,
    auth,
    functions,
    data
}
